import React, { useEffect, useState } from "react";
import "../styles/shared-ui.css";
import { useAppContext } from "../context/AppContext";
import BuildingDetailPage from "./BuildingDetailPage";

const BuildingCreatePage = () => {
  const { setActiveSection, setBuildingId, setBuildingFormMode } =
    useAppContext();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Ensure create intent survives refresh and no previous building is auto-loaded
    try {
      localStorage.removeItem("lastBuildingId");
    } catch {}
    setBuildingId(null);
    setBuildingFormMode("create");
    setActiveSection("building-create");
    setReady(true);
  }, [setActiveSection, setBuildingFormMode, setBuildingId]);

  if (!ready) return null;
  return <BuildingDetailPage />;
};

export default BuildingCreatePage;
